import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import EventInfoBody from './EventInfoBody';
import EventInfoData from './EventInfoData';

const EventInfoEdit = (props) => {
  const { content, data, block, selected } = props;

  return (
    <>
      <EventInfoBody content={content} data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <EventInfoData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

EventInfoEdit.propTypes = {
  data: PropTypes.object.isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

export default EventInfoEdit;
